import React from "react";
import ClientSidebarLinks from "./ClientSidebarLinks";

const Documents = () => {
  const documents = [
    { name: "Project Proposal.pdf", size: "2.4 MB", date: "2024-01-10" },
    { name: "Design Mockups.fig", size: "15.2 MB", date: "2024-01-15" },
    { name: "Requirements Doc.docx", size: "1.8 MB", date: "2024-01-12" },
    { name: "API Documentation.pdf", size: "3.1 MB", date: "2024-01-20" },
    { name: "Test Plan.xlsx", size: "900 KB", date: "2024-01-25" },
    { name: "Project Timeline.pdf", size: "1.2 MB", date: "2024-01-18" },
  ];

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }

        body {
          margin: 0;
          background: #f6f8fb;
        }

        .layout {
          display: flex;
          min-height: 100vh;
        }

        /* Sidebar */
        .sidebar {
          width: 230px;
          background: #fff;
          padding: 20px;
          border-right: 1px solid #e5e7eb;
        }

        .contact-btn {
          width: 100%;
          background: #22c55e;
          color: #fff;
          border: none;
          padding: 10px;
          border-radius: 6px;
          cursor: pointer;
          margin-bottom: 20px;
        }

        .menu a {
          display: block;
          padding: 10px;
          color: #555;
          border-radius: 6px;
          text-decoration: none;
          margin-bottom: 6px;
          cursor: pointer;
        }

        .menu a.active {
          background: #eafaf0;
          color: #22c55e;
          font-weight: 600;
        }

        /* Content */
        .content {
          flex: 1;
          padding: 24px;
        }

        .header h2 {
          margin: 0;
        }

        .header p {
          color: #6b7280;
          margin-top: 4px;
          font-size: 14px;
        }

        /* Documents Grid */
        .docs-grid {
          margin-top: 20px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }

        .doc-card {
          background: #fff;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .doc-left {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .doc-icon {
          width: 36px;
          height: 36px;
          background: #eafaf0;
          color: #22c55e;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }

        .doc-name {
          font-weight: 600;
          font-size: 14px;
        }

        .doc-meta {
          font-size: 12px;
          color: #6b7280;
          margin-top: 2px;
        }

        .download {
          cursor: pointer;
          font-size: 18px;
          color: #6b7280;
        }

        .download:hover {
          color: #22c55e;
        }

        /* Floating buttons */
        .floating {
          position: fixed;
          right: 20px;
          bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .fab {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 18px;
        }

        .green { background: #22c55e; }
        .blue { background: #3b82f6; }
        .red { background: #ef4444; }

        @media (max-width: 1100px) {
          .docs-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 700px) {
          .sidebar {
            display: none;
          }
          .docs-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="layout">
        {/* Sidebar */}
        <aside className="sidebar">
          <button className="contact-btn">Contact Team</button>
          <div className="menu">
            <ClientSidebarLinks active="documents" />
          </div>
        </aside>

        {/* Main Content */}
        <main className="content">
          <div className="header">
            <h2>Documents</h2>
            <p>Project-related documents and files</p>
          </div>

          <div className="docs-grid">
            {documents.map((doc, index) => (
              <div className="doc-card" key={index}>
                <div className="doc-left">
                  <div className="doc-icon">📄</div>
                  <div>
                    <div className="doc-name">{doc.name}</div>
                    <div className="doc-meta">
                      {doc.size} • {doc.date}
                    </div>
                  </div>
                </div>
                <div className="download">⬇️</div>
              </div>
            ))}
          </div>
        </main>

        {/* Floating buttons */}
        <div className="floating">
          <button className="fab green">💬</button>
          <button className="fab blue">📞</button>
          <button className="fab red">✉️</button>
        </div>
      </div>
    </>
  );
};

export default Documents;
